import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export const Logo = ({ dark = false, size = "md" }) => {
  const { content } = useContent() || {};
  const brand = content?.brand || {};
  const src = dark ? brand.logo_light || "/logo-light.png" : brand.logo_dark || "/logo-dark.png";
  const hCls = size === "lg" ? "h-28" : "h-12 lg:h-16";
  return (
    <Link to="/" data-testid="logo-home-link" className="inline-flex items-center shrink-0">
      <img src={src} alt="Bezalel Visionary" className={`${hCls} w-auto`} />
    </Link>
  );
};
